import { Controller } from "react-hook-form"
import { Field, Input } from "@chakra-ui/react"

export default function TextInput({ control, rules, type, name, value, label, help, feedback }) {
    return (
        <Controller
            name={name}
            control={control}
            defaultValue={value || ""}
            rules={rules}
            render={({ field, fieldState: { error } }) => {
                return (
                    <Field.Root invalid={!!error}>
                        <Field.Label htmlFor={name}>{label}</Field.Label>
                        <Input {...field} type={type} />
                        {help && <Field.HelperText>{help}</Field.HelperText>}
                        {error && <Field.ErrorText>{error.message}</Field.ErrorText>}
                        {feedback}
                    </Field.Root>
                )
            }}
        />
    )
}
